import useFeatureMap from '../../../../../hooks/useFeatureMap/index';
import { ReactComponent as EMRIcon } from '../../../../../assets/icons/EMRIcon.svg';
import { ReactComponent as AssignmentIcon } from '../../../../../assets/icons/assignment.svg';
import { addedUserByTypeEnum } from './types';

export default function useRegisterMethods() {
  const { pointclick,epicEmr, yardiEmr} = useFeatureMap();

  return [
    {
      type: addedUserByTypeEnum.manually,
      text: 'Manual',
      Icon: AssignmentIcon,
      isGoToNextStep: true,
      enabled: true,
    },
    {
      type: addedUserByTypeEnum.pointClick,
      text: 'Import from EMR',
      enabled: pointclick,
      Icon: EMRIcon,
    },
    {
      type: addedUserByTypeEnum.epic,
      text: 'Import from Epic EMR',
      enabled: epicEmr,
      Icon: EMRIcon,
    },
    {
      type: addedUserByTypeEnum.yardi,
      text: 'Import from Yardi EHR',
      enabled: yardiEmr,
      Icon: EMRIcon,
    },
  ].filter((method) => method.enabled);
}
